import React, { PureComponent } from 'react';
import PageWrapper from './../PageWrapper';
import PortfolioHeader from './PortfolioHeader';
import FilmProjectTop from './FilmProjectTop';
import FlexiblePortfolioLayout from './FlexiblePortfolioLayout';
import SocialShare from './../SocialShare';
import HelmetWrap from './../dom-elements/HelmetWrap';
import RelatedPosts from './../RelatedPosts';

export default class PhotoFilmProjectDetail extends PureComponent {
  
  
  render() {
    return (
      <PageWrapper pageId={'photo-film-project'}>
        {(this.props.layout == 'portfolio')
          ? <PortfolioHeader HeaderData={{
              headline: this.props.data.headline,
              description: this.props.data.description
            }}/>
          : <FilmProjectTop FilmData={this.props.data}/>
        }
        {(this.props.data.portfolio_layout.length != 0) && 
          <FlexiblePortfolioLayout LayoutItems={this.props.data.portfolio_layout} />
        }
        <HelmetWrap pageMeta={this.props.data.page_meta} />
        <SocialShare Meta={this.props.data.page_meta} />
        <RelatedPosts Posts={this.props.data.related_posts.posts}/>
      </PageWrapper>
    );
  };
};



// WEBPACK FOOTER //
// ./src/components/photo-film-project/PhotoFilmProjectDetail.js